const en = {
  callUs: "Call us",
  callAi: "Call AI",
  heroPrompt: "Not sure how to start? Talk to a Storelancer AI",
  openCall: "Call a Storelancer AI assistant",
  modalTitle: "Storelancer AI Expert",
  chooseLanguage: "Choose your call language",
  more: "More",
  moreLanguages: "Other languages",
  selectLanguage: "Select a language",
  whoToTalk: "Who would you like to talk to?",
  style_kind: "Kind & patient",
  style_fast: "Fast & practical",
  style_store: "Store & business",
  style_apps: "Apps & products",
  online: "Online",
  talkTo: "Call {name} ({style})",
  honestNote: "AI voice assistants — not real people.",
  costNote: "Calls may use credits per minute: {n} ⚡/min",
  freeNote: "Calls are free",
  balance: "Your balance: {n} ⚡",
  close: "Close",
  aiAssistant: "AI assistant",
  callDuration: "Call duration",
  connecting: "Connecting…",
  listening: "Listening…",
  thinking: "Thinking…",
  speaking: "Speaking…",
  ready: "Ready — type a message",
  micMuted: "Microphone muted",
  waitingConfirm: "Waiting for your confirmation",
  ended: "Call ended",
  endedSummary: "Call ended · {minutes} min · {credits} ⚡",
  mute: "Mute microphone",
  unmute: "Unmute microphone",
  hangUp: "Hang up",
  typeInstead: "Type instead",
  typePlaceholder: "Type your message…",
  send: "Send",
  captions: "Live captions",
  you: "You",
  steps: "Assistant actions",
  confirmTitle: "Confirm this action",
  confirm: "Confirm",
  cancel: "Cancel",
  greeting: "Hi, I'm {name}, your Storelancer AI assistant. How can I help you today?",
  sayConfirm: "Please confirm on screen.",
  sayNoCredits: "You're out of credits, so the call has ended. You can add credits and call again.",
  sayMaxDuration: "We've reached the maximum call length, so the call has ended.",
  reasonNoCredits: "The call ended because you ran out of credits.",
  reasonMaxDuration: "The call reached its maximum length.",
  reasonOther: "The call was ended by the server.",
  addCredits: "Add credits",
  openStore: "Open your store",
  callAgain: "Call again",
  errUnsupported: "Your browser can't recognise speech. You can still type your messages.",
  errPermission: "Microphone access was denied. Allow it in your browser settings, or type instead.",
  errNoMic: "No microphone was found. You can type instead.",
  errNetwork: "The speech service couldn't be reached. You can type instead.",
  errFailed: "Speech recognition stopped working. You can type instead.",
  errNoSpeechOut: "Your browser can't speak replies aloud — read them in the captions.",
  errStart: "The call couldn't be started.",
  errAiUnavailable: "The AI assistant isn't configured on this server.",
  errNoCreditsStart: "You don't have enough credits to start a call.",
  errTurn: "Something went wrong. Please try again.",
  avatarsTitle: "Call persona portraits",
  avatarsHelp: "Generates a photorealistic AI portrait for each call persona with the image model and stores it. The personas are fictional, not real people.",
  generateMissing: "Generate missing portraits",
  regenerateAll: "Regenerate all",
  generating: "Generating portraits… this can take a few minutes.",
  generatedResult: "{created} created, {skipped} already present, {failed} failed.",
  imagesNotConfigured: "Image generation isn't configured on this server (REPLICATE_API_TOKEN is not set).",
  noFemaleVoice: "No female voice is set up for this language yet, so {name}'s replies are shown as captions. An admin can choose one in Admin → AI & credits → Voice Lab.",
  voiceProviderError: "The voice service failed ({error}), so replies are shown as captions.",
  noMaleVoice: "No male voice is set up for this language yet, so {name}'s replies are shown as captions. An admin can choose one in Admin → AI & credits → Voice Lab.",
  chooseDialect: "Which Arabic?",
  dialectHint: "{name} will listen and reply in this dialect.",
};

export default en;
